import { useTranslation } from "react-i18next";
import { PreferenceComponent } from "../PreferenceComponent";

export const AssigneeNotificationsContent = ({
  tasksAssignedToMeEmailEnabledRef,
  userNotificationData,
  onChange,
}) => {
  const { t } = useTranslation(["Preferences"]);

  return (
    <div className="m-4 d-flex justify-content-between">
      <div className="fw-600 col-3">
        {t("NotificationPreferences.AssigneeNotifications")}
      </div>
      <div className="col-9">
        <div className="mb-2">
          {t("NotificationPreferences.AsATaskAssignee")}
        </div>
        <div className="notification-content">
          <PreferenceComponent
            ref={tasksAssignedToMeEmailEnabledRef}
            title={t("NotificationPreferences.TasksAssignedToMe")}
            checkedValue={userNotificationData?.TaskAssignedToMeEmailEnabled}
            change={onChange}
          />
        </div>
      </div>
    </div>
  );
};
